let language;
if (window.ocm && window.ocm.config) {
	language = window.ocm.config.language;
}
export const defaultLocale = language ? language : "de";
export const fallbackLocale = 'en';